var Backbone = require('backbone');

require('./Nav.less');

module.exports = Backbone.View.extend({
    el: '.Nav',

    events: {
        'click .Nav-a--sections': 'showSections'
    },

    showSections: function () {
        app.vent.trigger('PopupSections--show');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Nav/Nav.js
// module id = 153
// module chunks = 0